import { Divider, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { getCurrencySymbol } from "form/inventory/tools/common"
import { IPaymentInfo } from "payment/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

// https://stripe.com/docs/payments/quickstart

interface IPaymentInfoProps {
  paymentInfo: IPaymentInfo
}

export const PaymentInfo = ({ paymentInfo: { amount, tax: taxes, total, currency } }: IPaymentInfoProps) => (
    <FlexBox
      vertical
      ai="end"
      gap=".6rem"
      sx={{
        "& > div": {
          "& > p:nth-of-type(1)": {
            fontSize: ".9rem",
            minWidth: "9rem",
            textAlign: "right"
          },
          "& > p:nth-of-type(2)": {
            fontSize: ".9rem",
            minWidth: "7rem",
            maxWidth: "7rem",
            textAlign: "right"
          }
        }
      }}>
      <FlexBox>
        <Typography color="textPrimary">{translate("label.pay.amount")}</Typography>
        <Typography color="textSecondary">
          {amount} {getCurrencySymbol(currency)}
        </Typography>
      </FlexBox>
      <FlexBox>
        <Typography color="textPrimary">{translate("label.pay.taxes")}</Typography>
        <Typography color="textSecondary">
          {taxes} {getCurrencySymbol(currency)}
        </Typography>
      </FlexBox>
      <Divider sx={{ width: "100%" }} />
      <FlexBox>
        <Typography color="textPrimary" fontWeight="bold">
          {translate("label.pay.total")}
        </Typography>
        <Typography color="textSecondary" fontWeight="bold">
          {total} {getCurrencySymbol(currency)}
        </Typography>
      </FlexBox>
    </FlexBox>
  )
